'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProviderCampaignRest = function () {
  function ProviderCampaignRest($http) {
    (0, _classCallCheck3.default)(this, ProviderCampaignRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      LIST: 'campaigns/',
      DETAIL: 'campaigns/%1$s/',
      FIND_SLOTS: 'campaigns/%1$s/find-slots/',
      BOOK_APPOINTMENT: 'campaigns/%1$s/book-appointment/',
      UNBLOCK_APPOINTMENT: 'appointments/%1$s/'
    };
  }

  (0, _createClass3.default)(ProviderCampaignRest, [{
    key: 'create',
    value: function create(postData) {
      return this.$http.post(this.PATH.LIST, postData);
    }
  }, {
    key: 'update',
    value: function update(id, postData) {
      return this.$http.put(this.sprintf(this.PATH.DETAIL, id), postData);
    }
  }, {
    key: 'save',
    value: function save(postData) {
      return postData.id ? this.update(postData.id, postData) : this.create(postData);
    }
  }, {
    key: 'findSlots',
    value: function findSlots(id, postData) {
      return this.$http.post(this.sprintf(this.PATH.FIND_SLOTS, id), postData);
    }
  }, {
    key: 'bookAppointment',
    value: function bookAppointment(id, postData) {
      return this.$http.post(this.sprintf(this.PATH.BOOK_APPOINTMENT, id), postData);
    }
  }, {
    key: 'unblockAppointment',
    value: function unblockAppointment(id) {
      return this.$http.delete(this.sprintf(this.PATH.UNBLOCK_APPOINTMENT, id));
    }
  }, {
    key: 'getFindSlotOptions',
    value: function getFindSlotOptions(id) {
      return this.$http({ url: this.sprintf(this.PATH.FIND_SLOTS, id),
        method: 'OPTIONS',
        responseType: 'json' });
    }
  }, {
    key: 'getList',
    value: function getList(params) {
      return this.$http.get(this.PATH.LIST, { params: params });
    }
  }, {
    key: 'read',
    value: function read(id) {
      return this.$http.get(this.sprintf(this.PATH.DETAIL, id));
    }
  }]);
  return ProviderCampaignRest;
}();

exports.default = ProviderCampaignRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/ProviderCampaignResource.js
// module id = 319
// module chunks = 0